import { render } from "./SelectRolePopupRedesign.vue?vue&type=template&id=0a0b1931&scoped=true"
import script from "./SelectRolePopupRedesign.vue?vue&type=script&lang=js"
export * from "./SelectRolePopupRedesign.vue?vue&type=script&lang=js"

import "./SelectRolePopupRedesign.vue?vue&type=style&index=0&id=0a0b1931&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0b1931"]])

export default __exports__